<template>
    <section class="jsk-block pt-0" id="offer">
      <div class="container">
         <div class="row mb-5">
             <div class="col-12 text-center ">
                <h2>{{ $t("privateSchoolsPage.offerText") }}</h2>
            </div>
        <div class="col-12 px-lg-0 pt-5">
        <form
            id="reqOfferForm"
            @submit="checkForm"
            >
            <div class="row">
                <div class="col-12 col-lg-6 col-sm-12 form-group">
                    <label for="name">{{ $t('privateSchoolsPage.labelName') }}</label>
                    <input
                        id="name"
                        v-model="nameS"
                        type="text"
                        name="nameS"
                        class="form-control"
                    >
                </div>
                <div class="col-12 col-lg-6 col-sm-12 form-group">
                    <label for="name">{{ $t('privateSchoolsPage.labelPhone') }}</label>
                    <input
                        id="phone"
                        v-model="phoneS"
                        type="number"
                        name="phoneS"
                        class="form-control"
                        >
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6 col-sm-12 form-group">
                    <label for="email">{{ $t('privateSchoolsPage.labelEmail') }}</label>
                    <input
                        id="email"
                        v-model="emailS"
                        type="text"
                        name="emailS"
                        class="form-control"
                    >
                </div>
                <div class="col-12 col-lg-6 col-sm-12 form-group">
                    <label for="school">{{ $t('privateSchoolsPage.labelSchool') }}</label>
                    <input
                        id="school"
                        v-model="schoolS"
                        type="text"
                        name="schoolS"
                        class="form-control"
                    >
                </div>
            </div>    
            <div class="row">
                <div class="col-12 col-lg-12 col-sm-12 form-group text-center mt-4">
                    <input
                        type="submit"
                        :value="$t('privateSchoolsPage.offerBtn')"
                        class="btn btn-xl btn-secondary btn-round text-uppercase"
                    >
                    <p v-if="errors.length" class="mt-4">
                        <b>{{ $t('privateSchoolsPage.errorText') }}</b>
                        <ul class="list-unstyled mt-3">
                            <li v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </p>
                     <p class="mt-4">{{ returnMessage }}</p>
                </div>
                
            </div> 
        </form>
        </div> 
    </div>
    </div>
</section>
</template>

<script>
export default {
  name: "requestOfferForm",
  data() {
      return {
        errors: [],
        nameS: '',
        emailS: '',
        phoneS: '',
        schoolS: '',
        returnMessage: ''
    }
  },
  methods:{
    checkForm: function (e) {
     e.preventDefault();

      this.errors = [];

      if (!this.nameS) {
        this.errors.push(this.$t('privateSchoolsPage.nameError'));
      }
      if (!this.emailS) {
        this.errors.push(this.$t('privateSchoolsPage.emailError'));
      }
       if (!this.phoneS) {
        this.errors.push(this.$t('privateSchoolsPage.phoneError'));
      }
      if (!this.schoolS) {
        this.errors.push(this.$t('privateSchoolsPage.schoolNameError'));
      }

    this.axios.post('https://www.jskids.ro/php/schoolOfferForm.php', new FormData(e.target), {headers: { 'content-type': 'application/form-data' }})
        .then(function (response) {
            this.returnMessage = response.data;
            if (this.returnMessage == "OK") {
                this.returnMessage = this.$t('privateSchoolsPage.sucessMessage');
            }
        }.bind(this))
        .catch(function (error) {
            this.returnMessage = error;
            if (this.returnMessage) {
                this.returnMessage = this.$t('general.errorMessage');
            }
        }.bind(this));
    }
  }
};
</script>